import { render, staticRenderFns } from "./AllAreasActivities.vue?vue&type=template&id=937d048e"
import script from "./AllAreasActivities.vue?vue&type=script&lang=js"
export * from "./AllAreasActivities.vue?vue&type=script&lang=js"
import style0 from "./AllAreasActivities.vue?vue&type=style&index=0&id=937d048e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports